export type TypedAttributes = Record<string, string | undefined>;

export abstract class TypedElement<
  T extends TypedAttributes,
> extends HTMLElement {
  get typedAttributes(): T {
    const attributes = this.attributes;
    let mappedAttributes: Record<string, string> = {};

    for (let i = 0; i < attributes.length; i++) {
      const name = attributes[i].name;

      mappedAttributes[name] = attributes[i].value;
    }

    return mappedAttributes as T;
  }
}
